import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { Workspace } from '../../../../core/models/workspace.model';
import { Modalbase } from '../modalbase';
import { WorkspaceOption } from '../../workspace-option/workspace-option';

export interface SwitchWorkspaceModalData {
  workspaces: Workspace[];
  activeWorkspaceId: string | null;
}

/**
 * Cambio de workspace desde el menú de perfil. Cierra devolviendo el workspace elegido, o
 * `undefined` si el usuario cancela; quien lo abre decide qué hacer con la sesión.
 */
@Component({
  selector: 'app-switch-workspace-modal',
  standalone: true,
  imports: [TranslateModule, Modalbase, WorkspaceOption],
  templateUrl: './switch-workspace-modal.html',
  styleUrl: './switch-workspace-modal.scss',
})
export class SwitchWorkspaceModal {
  private dialogRef = inject(MatDialogRef<SwitchWorkspaceModal>);
  private data = inject<SwitchWorkspaceModalData>(MAT_DIALOG_DATA);

  protected workspaces: Workspace[] = this.data?.workspaces ?? [];
  protected activeWorkspaceId = this.data?.activeWorkspaceId ?? null;
  protected selectedWorkspaceId = signal<string | null>(this.data?.activeWorkspaceId ?? null);

  protected isSelected(workspace: Workspace): boolean {
    return workspace.id === this.selectedWorkspaceId();
  }

  protected isCurrentWorkspace(workspace: Workspace): boolean {
    return workspace.id === this.activeWorkspaceId;
  }

  protected onSelectWorkspace(workspace: Workspace): void {
    this.selectedWorkspaceId.set(workspace.id);
  }

  protected close(): void {
    this.dialogRef.close();
  }

  protected onContinue(): void {
    const selected = this.workspaces.find((workspace) => workspace.id === this.selectedWorkspaceId());
    this.dialogRef.close(selected ?? undefined);
  }
}
